export default __webpack_public_path__ + "static/media/windmill.9d4fef56.svg";